<template>
  <div>
    <v-tabs
      v-model="tabmodule"
      align-with-title
    >
      <v-tab>
        Forte
      </v-tab>
      <v-tab>
        A melhorar
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabmodule">
      <v-tab-item
        v-for="item in items"
        :key="item.title"
      >
        <v-container fluid>
          <v-row
            v-for="(m,index) in item.modules"
            v-show="index<limit"
            :key="index"
          >
            <v-col
              cols="4"
              :md="4"
              :sm="12"
              class="text-center"
            >
              <i :class="item.icon" />
              <div 
                v-if="m.subject"
                class="font-weight-bolder p-0" 
                style="hyphens: auto;"
              >
                {{ m.subject.name }}
              </div>
            </v-col>
            <v-col class="d-flex justify-content-center align-items-center text-center">
              {{ m.name }}
            </v-col>
          </v-row>
          <v-row v-show="item.modules.length > 5">
            <v-col class="d-flex justify-content-center">
              <v-icon 
                @click="limit = limit === 5 ? 40 : 5"
              >
                {{ limit <= 5 ? 'fa fa-chevron-down' : 'fa fa-chevron-up' }}
              </v-icon>  
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {},
  data() {
    return {
      tabmodule: 0,
      limit: 5,
    }
  },

  computed: {
    ...mapGetters(['high_performance_modules','low_performance_modules',]),
    items(){
      return [
        {
          title: 'Forte',
          icon: 'far fa-smile text-success mr-1',
          modules: this.high_performance_modules.length ? this.high_performance_modules : [{name: 'Sem dados disponíveis'}],
        },
        {
          title: 'A melhorar',
          icon: 'far fa-frown text-danger mr-1',
          modules: this.low_performance_modules.length ? this.low_performance_modules : [{name: 'Sem dados disponíveis'}],
        }
      ]
    }
  },
}
</script>
